module.exports = __webpack_public_path__ + "img/kurasu.5858173d.png";